'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { ApolloNextAppProvider } from '@apollo/client-integration-nextjs';
import useLogoutClient from 'data-hooks/useUserData/useLogoutClient';
import makeApolloClient from './makeApolloClient';
function ApolloClientProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const logoutClient = useLogoutClient();
  let t1;
  if ($[0] !== logoutClient) {
    t1 = makeApolloClient(logoutClient);
    $[0] = logoutClient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const makeClient = t1;
  let t2;
  if ($[2] !== children || $[3] !== makeClient) {
    t2 = <ApolloNextAppProvider makeClient={makeClient}>{children}</ApolloNextAppProvider>;
    $[2] = children;
    $[3] = makeClient;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export default ApolloClientProvider;